// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__33ey1","header":"ReportDetails_header__2i4n8","title":"ReportDetails_title__1ZP90","left":"ReportDetails_left__zt-DX"};